export const NoAccessParents = ({ className }: { className?: string }) => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    className={className}
  >
    <path
      d="M55 48.8H50.8182V13.1C50.8182 11.9402 49.8821 11 48.7273 11H15.2727C14.118 11 13.1818 11.9402 13.1818 13.1V48.8H9V53H55V48.8Z"
      fill="#B2ABAB"
    />
  </svg>
);
